import { render } from "./usuallyGame.vue?vue&type=template&id=3bef1c8e"
import script from "./usuallyGame.vue?vue&type=script&lang=js"
export * from "./usuallyGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__